import { render } from "./TRTDashboardView.vue?vue&type=template&id=180d501c&scoped=true"
import script from "./TRTDashboardView.vue?vue&type=script&lang=js"
export * from "./TRTDashboardView.vue?vue&type=script&lang=js"

import "./TRTDashboardView.vue?vue&type=style&index=0&id=180d501c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180d501c"]])

export default __exports__